// extracted by mini-css-extract-plugin
export default {"soccerImg":"App_soccerImg__eR-20","initImage":"App_initImage__9dheq","logoWrapper":"App_logoWrapper__hlx9f","app":"App_app__GuJBs"};